import data from "../../../../../src/Token/Token.docs.json";
import { AvatarToken, IssueLabelToken, Token } from '@primer/react';
import * as React from 'react';
export default {
  data,
  AvatarToken,
  IssueLabelToken,
  Token,
  React
};